<template>
  <div>
    <list-layout
      :columnsAll="columnsAll"
      :columnDefaultSelected="columnDefaultSelected"
      :fetch-id="id"
      :getTableDataFunc="getTableDataFunc"
      :toolsList="['setting', 'reload', 'leftTool', 'search']"
      :search-type-options="[
      { label: '名称', value: 'name' }
    ]"
      :refresh="refresh"
    >
      <template #leftTool>
        <upload-button
          v-permission="{ action: 'service.service.update' }"
          @click="$refs.uploadModal.show()"
        ></upload-button>
      </template>

      <template #createdBy="{ slotProps }">
        <a-tooltip placement="topLeft" :title="slotProps.text.nickname">
          {{ slotProps.text.nickname }}
        </a-tooltip>
      </template>

      <template #operation="{ slotProps }">
        <a-button icon="download" type="link" size="small" @click="download(slotProps.record)">下载</a-button>
        <delete-button
          v-permission="{ action: 'service.service.update', effect: 'disabled' }"
          @confirm="confirm(slotProps.record.id)"
        ></delete-button>
      </template>
    </list-layout>

    <upload-modal ref="uploadModal" :service-id="id" @confirm="refresh=true"></upload-modal>
  </div>
</template>

<script>
import {
  deleteServiceApproval,
  downloadServiceApproval,
  getServiceApprovalList
} from '@/api/service'
import DeleteButton from '@/components/button/DeleteButton.vue'
import ListLayout from '@/components/ListLayout.vue'
import UploadButton from '@/components/button/UploadButton.vue'

import UploadModal from './modules/UploadModal.vue'

export default {
  name: 'ApprovalTable',
  components: {
    UploadModal,
    DeleteButton,
    ListLayout,
    UploadButton
  },
  data () {
    return {
      id: this.$route.params.id,
      refresh: false,
      columnsAll: [
        {
          dataIndex: 'name',
          title: '名称',
          fixed: 'left',
          width: 300,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'created_at',
          title: '创建时间',
          width: 200
        },
        {
          dataIndex: 'created_by',
          title: '创建人',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'createdBy'
          }
        }
      ],
      columnDefaultSelected: [
        'name',
        'created_at',
        'created_by'
      ],
      getTableDataFunc: getServiceApprovalList
    }
  },
  methods: {
    download (approval) {
      downloadServiceApproval(this.id, approval.id).then(res => {
        const blob = new Blob([res], { type: res.type })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = approval.name
        a.click()
        window.URL.revokeObjectURL(url)
      })
    },
    async confirm (approvalId = '') {
      if (approvalId) {
        await deleteServiceApproval(this.id, approvalId).then(res => {
          this.$message.success(res.message)
        })
      }
      this.refresh = !this.refresh
    }
  }
}
</script>
